import { createSlice } from '@reduxjs/toolkit'

//Za prebacivanje iz register u login
const tranzicijaDataSlice = createSlice({
    name: 'tranzicijaData',
    initialState: { modalTrigger: false },
    reducers: {
        setmodalTrigger: (state, action) => {
            state.modalTrigger = action.payload;
        },
        resetmodalTrigger: (state) => {
            state.modalTrigger = false;
        }
    }
})

export const { setmodalTrigger,resetmodalTrigger  } = tranzicijaDataSlice.actions

export default tranzicijaDataSlice.reducer

export const selectmodalTrigger = (state) => state.transformacijaData.modalTrigger;